<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaikanaeWhenua"></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WaikanaeWaiFieldWaterSampling"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.PekaPekaContaminants"></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.PaekakarikiContaminants"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.ParaparaumuTaiao"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WhareroaBeachRiverFlow"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.TeHoroWhakaaweWhenua"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.TaiaoTeHoro"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.TaiaoOtaraua"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WhakaaweWhenuaOtaraua"></app-basic-cartesian-chart>
